export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14191.6caa7909.jpg";